<ng-container *ngIf="opkraevningState" [ngSwitch]="opkraevningState">
  <div class="flex-wrap flex-wrap--flex-start flex-wrap--align-center tiny-text">
    <ng-container *ngSwitchCase="opkraevningStateEnum.FullyOpkraevet">
      <mat-icon svgIcon="thumb-up" class="green"></mat-icon>
      <i class="no-line-height">Fuldt opkrævet</i>
    </ng-container>
    <ng-container *ngSwitchCase="opkraevningStateEnum.NotOpkraevet">
      <mat-icon svgIcon="thumb-down" class="red"></mat-icon>
      <i class="no-line-height">IKKE opkrævet</i>
    </ng-container>
    <ng-container *ngSwitchCase="opkraevningStateEnum.PartOpkraevet">
      <mat-icon svgIcon="point" class="orange"></mat-icon>
      <i class="no-line-height">Delvist opkrævet</i>
    </ng-container>
    <ng-container *ngSwitchDefault></ng-container>
  </div>
</ng-container>
